import { Controller } from "@hotwired/stimulus"
import { browserTimeZone, sameOffset } from "../helpers/time_zones"

const STORAGE_PREFIX = "schedule-tz-hint-dismissed:"

// Suggests the device time zone when it differs from the cabinet setting.
export default class extends Controller {
  static targets = ["text", "field"]
  static values = { current: String, message: String }

  connect() {
    const browser = browserTimeZone()
    if (!browser || sameOffset(this.currentValue, browser)) return
    if (this.dismissed(browser)) return
    this.browser = browser
    if (this.hasFieldTarget) this.fieldTarget.value = browser
    if (this.hasTextTarget) this.textTarget.textContent = this.messageValue.replace("__BROWSER__", browser)
    this.element.hidden = false
  }

  dismiss() {
    this.element.hidden = true
    try {
      window.localStorage.setItem(this.storageKey(this.browser), "1")
    } catch (_error) {
      // Private mode: the hint comes back next time.
    }
  }

  dismissed(browser) {
    try {
      return window.localStorage.getItem(this.storageKey(browser)) === "1"
    } catch (_error) {
      return false
    }
  }

  storageKey(browser) {
    return `${STORAGE_PREFIX}${this.currentValue}:${browser}`
  }
}
